import { useEffect } from 'react';

/**
 * Keeps the fabric canvas the same size as its card: on mount, whenever the
 * card resizes, and after any render that left it another size (resetZoom
 * rescales the dimensions). Objects keep their coordinates; only the
 * visible area changes.
 */
const useCanvasFill = (canvasRef, cardRef, enabled) => {
    useEffect(() => {
        const canvas = canvasRef.current;
        const card = cardRef.current;
        if (!enabled || !canvas || !card) return undefined;

        const fit = () => {
            const { clientWidth: width, clientHeight: height } = card;
            if (!width || !height) return;
            if (canvas.getWidth() === width && canvas.getHeight() === height) return;
            canvas.setDimensions({ width, height });
            canvas.renderAll();
        };

        fit();
        const observer = new ResizeObserver(fit);
        observer.observe(card);
        canvas.on('after:render', fit);
        return () => {
            observer.disconnect();
            canvas.off('after:render', fit);
        };
    }, [canvasRef, cardRef, enabled]);
};

export default useCanvasFill;
